import React from 'react';

const Wrapper = ({ children, className }) => {
    return (
        <div className={`max-w-screen w-full mx-auto lg:pr-28 pt-2 pb-2 pr-8 pl-8 lg:pl-28 ${className}`}>
            {children}
        </div>
    );
};

export default Wrapper;
